import { useMediaQuery } from "@chakra-ui/react";
import { useRecoilValue } from "recoil";
import BooksIcon from "../components/BooksIcon";
import { selectionAtom } from "../store/selection.atom";
import AllCategories from "./MainView/AllCategories";
import Post from "./Post";
import AllPosts from "./PostsView/AllPosts";

const Content = () => {
  const [isMedium, isLarge] = useMediaQuery([
    "(min-width: 768px)",
    "(min-width: 1024px)",
  ]);
  const selection = useRecoilValue(selectionAtom);

  return (
    <div className="flex-1 md:flex md:bg-rss-primary-color/5">
      <AllCategories
        disableAnimation={isMedium && (selection.blog === undefined || isLarge)}
      />
      <AllPosts disableAnimation={isLarge} />
      <div
        className={`hidden h-full w-full flex-1 items-center justify-center self-stretch md:flex ${(isMedium && !isLarge && selection.category && "!hidden") || (isLarge && selection.blog !== undefined && "!hidden")}`}
      >
        <BooksIcon />
      </div>
      <Post />
    </div>
  );
};

export default Content;
